import { render } from "./ValvesAg.vue?vue&type=template&id=35a72806&scoped=true"
import script from "./ValvesAg.vue?vue&type=script&lang=js"
export * from "./ValvesAg.vue?vue&type=script&lang=js"

import "./ValvesAg.vue?vue&type=style&index=0&id=35a72806&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35a72806"]])

export default __exports__